<template>
  <div v-if="rates && !ratingError && !reviewsError" id="customer-reviews">
    <ReviewsBlockProxy
      :link="{
        name: REVIEWS_ROUTES.PAGES.LANDING,
        params: {
          uuid: id,
          slugV2: slug,
          locale,
        },
      }"
      :next-reviews-cursor="reviews?.nextCursor"
      :pending-summary="ratingSummaryPending"
      :previous-reviews-cursor="reviews?.previousCursor"
      :product-id="undefined"
      :product-title="title"
      :rating="rates"
      :rating-summary
      :reviews="reviews?.results || []"
      :reviews-pending="pendingReviews"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import ReviewsBlockProxy from '~/scopes/reviews/reviews-display/components/ReviewsBlockProxy/ReviewsBlockProxy.vue'
import { useRatingDetailsSummary } from '~/scopes/reviews/reviews-display/composables/useRatingDetailsSummary'
import { ROUTES as REVIEWS_ROUTES } from '~/scopes/reviews/route-names'

import { useProductListRating } from '../../composables/useProductListRating'
import { useProductListReviews } from '../../composables/useProductListReviews'

const props = defineProps<{
  title: string
  id: string
  slug: string
}>()

const locale = useI18nLocale()

const { data: rates, error: ratingError } = useProductListRating(props.id)
const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useProductListReviews(props.id)

const { data: ratingSummary, pending: ratingSummaryPending } =
  useRatingDetailsSummary()
</script>
